import { Component } from '@angular/core';

@Component({
  selector: 'app-wallet-img',
  templateUrl: './wallet-img.component.html',
  styleUrls: ['./wallet-img.component.scss']
})
export class WalletImgComponent {

}
